<template>
  <v-app id="inspire">
    <app-drawer
      v-if="$route.name !== 'login'"
      :drawer="drawer"
      @toggleDrawer="toggleDrawer"
    />

    <app-bar v-if="$route.name !== 'login'" @toggleDrawer="toggleDrawer" />

    <v-main>
      <v-container
        class=""
        fluid
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getStorage, clearStorage } from './_helpers'
import { authHeader } from './_helpers';

export default {
  name: 'App',

  components: {
    AppBar: () => import('./components/core/AppBar'),
    AppDrawer: () => import('./components/core/AppDrawer'),
  },

  data: () => ({
    drawer: true,
  }),
  async mounted () {
    let admin = getStorage('_admin')
    if (!admin || !admin.id || !admin._token || !admin.username) {
      clearStorage('_admin')
      this.$router.push({ name: 'login' })
    }
    if (!await this.validateToken())
      this.$router.push({ name: 'login' })
  },
  methods: {
    toggleDrawer (val) {
      this.drawer = val
    },
    async validateToken () {
      try {
        const { data } = await this.$http.get(`/back-office/verify-token`, authHeader())
        return data
      } catch (err) {
        return false
      }
    }
  },
};
</script>

<style>
  .v-divider {
    margin: 20px 0;
  }
  .row > .col > .row > .col {
    padding-top: 0;
    padding-bottom: 0;
  }
  .page-title {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
  }
</style>